import React from 'react';

import UI from '#front-credpago';

import useResizer from '../../../utils/useResizer';
import { LogoLoftCredpago } from '../../logos/LogoLoftCredpago';
import * as S from './styles';

const Partnership = ({ data }) => {
  const isMobile = useResizer();

  const description = (
    <>
      <UI.Description
        color="blue"
        style={
          isMobile
            ? { marginTop: 20, textAlign: 'right', color: '#001c4a' }
            : { marginTop: 20, textAlign: 'left', color: '#001c4a' }
        }
      >
        A credibilidade aliada à tecnologia de uma empresa do Grupo Loft, startup do setor imobiliário que está no topo
        da lista dos maiores unicórnios do Brasil.
      </UI.Description>

      <UI.Description
        color="gray"
        style={isMobile ? { marginTop: 20, textAlign: 'right' } : { marginTop: 20, textAlign: 'left' }}
      >
        Empresas independentes, mas debaixo do mesmo guarda-chuva, CredPago e Loft uniram forças em julho de 2021 para
        agregar mais tecnologia e ampliar a oferta de soluções em compra, venda, aluguel sem fiador e financiamento para
        o mesmo canal de distribuição: imobiliárias e corretores parceiros.
      </UI.Description>
    </>
  );

  return (
    <S.Wrapper id="btg">
      <S.Container>
        <UI.Row>
          <S.ColumnImg responsive={{ xs: 12, md: 6 }}>
            <S.WrapperImg>
              <S.ImgBuilding fluid={data.Building.childImageSharp.fluid} />
            </S.WrapperImg>
          </S.ColumnImg>

          <UI.Col style={{ alignSelf: 'center' }} responsive={{ xs: 12, md: 6 }}>
            <UI.Title
              level={2}
              fontWeight={700}
              splitLabel={['Parceria e tecnologia na', 'locação de imóveis']}
              style={isMobile ? { textAlign: 'right' } : {}}
            />
            {description}
            <S.WrapperLogoCredBtg>
              <LogoLoftCredpago />
            </S.WrapperLogoCredBtg>
          </UI.Col>
        </UI.Row>
      </S.Container>
    </S.Wrapper>
  );
};

export default Partnership;
